import React from 'react';
import { Table } from 'react-bootstrap';
import ImageThumbnail from 'components/ImageThumbnail';
import { PromotionalProduct } from 'lib/types';
import _ from 'lodash';

interface IPromotionProductsListDesktopProps {
    items: PromotionalProduct[];
    selectedCount: Map<PromotionalProduct, number[]>;
    makeCountInputs: (product: PromotionalProduct) => React.ReactNode;
}

const PromotionProductsListDesktop = ({ items, selectedCount, makeCountInputs }: IPromotionProductsListDesktopProps) => (
    <Table size='sm' borderless striped className='tr3 tr4 tr5 products-table'>
        <thead>
            <tr>
                <th>Foto</th>
                <th>Opis</th>
                <th className='PromotionProducts-number-th'>Ilość</th>
                <th>Punkty</th>
                <th>Cena</th>
            </tr>
        </thead>
        <tbody>
            {_.map(items, (product) => (
                <tr
                    key={product.symKar}
                    className={
                        selectedCount.get(product)?.some((num) => num !== 0) ?
                            'PromotionProducts-selected-row' :
                            ''
                    }
                >
                    <td style={{ padding: 5 }} className='PromotionProducts-photo-td'>
                        {product.photo && (
                            <ImageThumbnail
                                src={product.photo}
                                alt=''
                                aria-describedby={`PromotionProducts-desc-${product.symKar}`}
                            />
                        )}
                    </td>
                    <td id={`PromotionProducts-desc-${product.symKar}`}>{product.description}</td>
                    <td style={{ padding: '0 20px 0 0' }} className='count-inputs'>{makeCountInputs(product)}</td>
                    <td>{product.points.toLocaleString('fr-FR')}</td>
                    <td>{product.price.toFixed(2)}</td>
                </tr>
            ))}
        </tbody>
    </Table>
);

export default PromotionProductsListDesktop;
